export enum DimensionColorTypes {
  textBar = "textBar",
  bar = "bar",
  text = "text"
}

export const PrintableCalendarDimensionColor = [
  {
    name: "Text and bar",
    value: DimensionColorTypes.textBar
  },
  {
    name: "Bar",
    value: DimensionColorTypes.bar
  },
  {
    name: "Text",
    value: DimensionColorTypes.text
  }
]